"use client";

import { useEffect } from "react";
import Player from "xgplayer";
import Image from "next/image";
export default function VideoPlayer({
  src = "./video.mp4"
}: {
  src: string;
}) {
  useEffect(() => {
    const player = new Player({
      height: 600,
      width: 340,
      fitVideoSize: "fixed",
      id: "vs",
      url: src,
      autoplayMuted: true,
      autoplay: true,
      loop: true,
      cssFullscreen: false
    });
  }, []);
  const translateStyle: React.CSSProperties = {
    transform: "translate(6px, 16px) rotateY(-3deg)",
    transformOrigin: "50% 50%",
    overflow: "hidden",
    borderTopLeftRadius: "40px",
    borderTopRightRadius: "32px",
    height: "600px"
  };
  return <div className=" mt-32 flex" data-sentry-component="VideoPlayer" data-sentry-source-file="VideoPlayer.tsx">
      <div className="z-10" style={{
      perspective: "400px"
    }}>
        <div className="w-[340px] transform-gpu" style={translateStyle}>
          <div id="vs"></div>
        </div>
      </div>
      <Image src="/smartphone.webp" style={{
      height: 672,
      width: 370,
      position: "absolute"
    }} alt="smartphone" width="370" height="672" data-sentry-element="Image" data-sentry-source-file="VideoPlayer.tsx" />
    </div>;
}